/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export type IAPI76510ResListItem = {};
    
  



export interface API76510Req {
  
  /** (String) */
  dataType?: string;
    
  /** (Integer) */
  page?: string;
    
  /** (Integer) */
  pageSize?: string;
    
  /** (String) */
  keyword?: string;
    
};



export interface API76510Res {
  /** T  */
  list?: IAPI76510ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76510 任务要素选择

export interface IUseGetAPI76510Return {
  /** 任务要素选择: 接口请求状态 */
  isAPI76510Loading: boolean;
  /** 任务要素选择: 接口请求返回数据 */
  dataAPI76510: API76510Res;
  /**  任务要素选择: 接口数据请求方法 */
  fetchAPI76510Data: (inputs: API76510Req, config?: YWRequestConfig) => Promise<API76510Res>;
  /** 任务要素选择: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76510 = ():IUseGetAPI76510Return => {
  let isMount = true;
  const [isAPI76510Loading, setIsAPI76510Loading] = useState(false);
  const [dataAPI76510, setDataAPI76510] = useState<API76510Res>({} as API76510Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/data/element`;

  const fetchAPI76510Data = async (inputs: API76510Req, config?: YWRequestConfig): Promise<API76510Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76510Req>) || {}) as API76510Req;
    
  
    if ( isMount ) {
      setIsAPI76510Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76510Res>(`${basePath}/yoaichat-web/task/instance/data/element?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76510(res || {} as API76510Res);
        setIsAPI76510Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76510Loading(false);
      }
      return false as unknown as API76510Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76510Loading,
    dataAPI76510,
    fetchAPI76510Data,
    requestUrl,
  }
}

